var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaysonSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 288.155 288.155",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M268.716,115.677c-10.702,0-19.378,8.649-19.434,19.337c-23.02-0.545-45.599,6.505-66.54,17.426l-32.435-95.787 c7.676-2.599,13.208-9.846,13.208-18.4c0-10.736-8.703-19.439-19.439-19.439s-19.439,8.703-19.439,19.439 c0,8.554,5.532,15.801,13.208,18.4l-32.474,95.903c-20.929-10.91-43.492-17.95-66.497-17.406c0-0.012,0.002-0.023,0.002-0.035 c0-10.736-8.703-19.439-19.439-19.439S0,124.38,0,135.116c0,10.736,8.703,19.439,19.439,19.439c6.321,0,11.92-3.031,15.471-7.703 c13.722,11.857,32.076,37.776,35.311,92.514c-8.053,0.264-14.505,6.858-14.505,14.975c0,8.284,6.716,15,15,15h146.724 c8.284,0,15-6.716,15-15c0-8.12-6.456-14.716-14.513-14.975c3.208-54.749,21.53-80.705,35.257-92.596 c3.547,4.72,9.174,7.786,15.533,7.786c10.736,0,19.439-8.703,19.439-19.439C288.155,124.38,279.452,115.677,268.716,115.677z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaysonSvg);
export default __webpack_public_path__ + "static/media/playson-svg.0e313bb5425e5b9024157afc685932d3.svg";
export { ForwardRef as ReactComponent };